import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { KeyValue } from './contributor';
import { Gridstyles } from './index';
// eslint-disable-next-line
import {
  checkIfOtherSetupFeeApplicableReqd,
  currencyConversion,
  isFieldApplicable,
  isFieldTypeTabular,
  isFieldValueFixed,
  isFieldValueInWords,
  isFieldVariable,
} from '../../utils/utilityFunctions';
import { styles } from '../../Styles/styles';
import { ExitLoadComponent, ExitLoadDetails } from './ExitLoadDetails';
import { YES_NO_BOOLEAN_MASTER } from '../../utils/constant';

export default function InvestAndPaymentDetails({
  application,
}: {
  application: Partial<ApplicationProps>;
}): JSX.Element {
  return (
    <>
      <Box sx={styles.ApplicationDetailsCommonLayout} mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Investment Details
            </Typography>
            <Gridstyles>
              <Grid
                item
                container
                pt={2}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <KeyValue
                  title={'Accredited Investor'}
                  description={
                    YES_NO_BOOLEAN_MASTER[application.isAccreditedInvestor?.toString() || '']
                  }
                />
                <KeyValue title={'Fund (Scheme)'} description={application.scheme?.schemeName} />
                <KeyValue
                  title={application.isTopup ? 'Top Up Plan' : 'Class Plan'}
                  description={application.plan?.planDescription}
                />
                <KeyValue
                  title={(application.isTopup ? 'Existing ' : '') + 'Commitment Amount'}
                  description={application.commitmentAmount}
                  amount={currencyConversion(
                    application.commitmentAmount,
                    application.plan?.currency
                  )}
                />
                {application?.isTopup && (
                  <KeyValue
                    title={'Top Up Commitment Amount'}
                    description={application?.topupAmount}
                    amount={currencyConversion(
                      application?.topupAmount,
                      application.plan?.currency
                    )}
                  />
                )}
                {isFieldApplicable(application?.managementFeeApplicable || '') && (
                  <KeyValue
                    title={'Management Fees Rate %'}
                    description={application?.managementFeesRate}
                  />
                )}
                {isFieldApplicable(application?.placementFeeApplicable || '') && (
                  <KeyValue title={'Placement Fees %'} description={application?.placementFee} />
                )}
                {(isFieldVariable(
                  application?.operatingExpenseType || '',
                  application?.operatingExpenseApplicable || ''
                ) ||
                  isFieldValueFixed(
                    application?.operatingExpenseType || '',
                    application?.operatingExpenseApplicable || ''
                  )) && (
                  <KeyValue
                    title={
                      application.isTopup ? 'Topup Operating Expense %' : 'Operating Expense %'
                    }
                    description={application?.operatingExpenses}
                  />
                )}
                {isFieldApplicable(application?.additionalReturnApplicable || '') && (
                  <KeyValue
                    title={application.isTopup ? 'Top Up Additional Return' : 'Additional Return'}
                    description={application?.defaultAdditionalReturn}
                  />
                )}
                {isFieldApplicable(application?.carryShareApplicable || '') && (
                  <KeyValue
                    title={application.isTopup ? 'Top Up Carry Share' : 'Carry Share'}
                    description={application?.carryShare}
                  />
                )}
                {/* <KeyValue title={'Tax Rate'} description={application.taxRate} /> */}
                {/* <KeyValue title={'DrawDown Number'} description={application.drawDownNumber} /> */}
                {!application.isTopup &&
                  isFieldApplicable(application?.contributionAmtApplicable) && (
                    <KeyValue
                      title={'Contribution Amount'}
                      description={application.contributionChequeAmount}
                      amount={currencyConversion(
                        application.contributionChequeAmount,
                        application.plan?.currency
                      )}
                    />
                  )}
                {application.isTopup &&
                  isFieldApplicable(application?.contributionAmtApplicable) && (
                    <KeyValue
                      title={'Top Up Contribution Amount'}
                      description={application.topupContributionAmount}
                      amount={currencyConversion(
                        application.topupContributionAmount,
                        application.plan?.currency
                      )}
                    />
                  )}
                {(isFieldVariable(
                  application.setupFeeType || '',
                  application.setupFeeApplicable || ''
                ) ||
                  isFieldValueFixed(
                    application.setupFeeType || '',
                    application.setupFeeApplicable || ''
                  )) && (
                  <KeyValue
                    title={
                      application.isTopup
                        ? 'Topup Setup Fee Percentage %'
                        : 'Setup Fee Percentage %'
                    }
                    description={application.setupFeePercentage}
                  />
                )}
                {isFieldApplicable(application?.otherSetUpFeeApplicable || '') &&
                  checkIfOtherSetupFeeApplicableReqd(
                    application.setupFeeType || '',
                    application?.setupFeeApplicable || ''
                  ) && (
                    <>
                      <KeyValue
                        title={'Setup Fee Amount'}
                        description={application.setupFeeAmount}
                        amount={currencyConversion(
                          application.setupFeeAmount,
                          application.plan?.currency
                        )}
                      />
                      <KeyValue
                        title={'GST (GST On Setup Fee Amount)'}
                        description={application.setupFeeGST}
                        amount={currencyConversion(
                          application.setupFeeGST,
                          application.plan?.currency
                        )}
                      />
                      <KeyValue
                        title={'Total Setup Fee'}
                        description={application.totalSetupFee}
                        amount={currencyConversion(
                          application.totalSetupFee,
                          application.plan?.currency
                        )}
                      />
                      <KeyValue
                        title={'TDS'}
                        description={application.setupFeeTDS}
                        amount={currencyConversion(
                          application.setupFeeTDS,
                          application.plan?.currency
                        )}
                      />
                      <KeyValue
                        title={'Setup Fee Payable'}
                        description={application.netSetupFeeLessTDS}
                        amount={currencyConversion(
                          application.netSetupFeeLessTDS,
                          application.plan?.currency
                        )}
                      />
                    </>
                  )}

                {isFieldApplicable(application?.hurdleRateApplicable || '') && (
                  <KeyValue title={'Hurdle Rate %'} description={application?.hurdleRate} />
                )}
                {isFieldApplicable(application?.performanceFeeApplicable || '') && (
                  <KeyValue title={'Performance Fee %'} description={application?.performanceFee} />
                )}
                {isFieldApplicable(application?.exitChargeApplicable || '') && (
                  <KeyValue title={'Exit Charge %'} description={application?.exitCharge} />
                )}
                <KeyValue
                  title={'Total Amount Payable'}
                  description={application.totalAmountPayable}
                  amount={currencyConversion(
                    application.totalAmountPayable,
                    application.plan?.currency
                  )}
                />
                {application?.isTopup && (
                  <KeyValue
                    title={'Aggregate Commitment Amount'}
                    description={application.aggregateAmount}
                    amount={currencyConversion(
                      application.aggregateAmount,
                      application.plan?.currency
                    )}
                  />
                )}

                {isFieldValueInWords(
                  application?.setupFeeType || '',
                  application?.setupFeeApplicable || ''
                ) && (
                  <Grid item xs={6} pb={2}>
                    <ExitLoadComponent
                      exitLoad={application?.setupFeeInWords || ''}
                      label="Setup Fee"
                    />
                  </Grid>
                )}
                {isFieldValueInWords(
                  application?.operatingExpenseType || '',
                  application?.operatingExpenseApplicable || ''
                ) && (
                  <Grid item xs={6} pb={2}>
                    <ExitLoadComponent
                      exitLoad={application?.operatingExpenseInWords || ''}
                      label="Operating Expenses"
                    />
                  </Grid>
                )}
                {isFieldApplicable(application?.exitLoadDetailsApplicable || '') && (
                  <>
                    {isFieldTypeTabular(application?.exitLoadDetailsType || '') ? (
                      <ExitLoadDetails exitLoadDetails={application.exitLoadDetails || []} />
                    ) : (
                      <Grid item xs={6} pb={2}>
                        <ExitLoadComponent
                          exitLoad={application?.exitLoad || ''}
                          label="Exit Load"
                        />
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
            </Gridstyles>
          </Grid>
        </Box>
        <Box sx={{ p: 2 }}>
          {/* <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
              Payment Details
            </Typography>
            <Gridstyles>
              <Grid
                item
                container
                pt={2}
                pb={5}
                rowSpacing={6}
                columnSpacing={13}
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <KeyValue title={'Payment Bank Name'} description={application.paymentBankame} />
                <KeyValue
                  title={'Payment Bank Account Number'}
                  description={application.paymentBankAccountNumber}
                />
                <KeyValue
                  title={'Payment Bank Account Type'}
                  description={application.paymentBankAccontType}
                />
                <KeyValue title={'Mode Of Payment'} description={application.modeOfPayment} />
                <KeyValue
                  title={'Payment/Cheque Date'}
                  description={formatShortDate(application.chequeDate)}
                />
                <KeyValue title={'Payment Ref No'} description={application.paymentRefNo} />
              </Grid>
            </Gridstyles>
          </Grid> */}
        </Box>
      </Box>
    </>
  );
}
